module.exports = "/assets/data/6fcc21ffd3265d5d69bcc425175f18d6-IP19.data.json";